import BPIcon from 'components/BionicUI/icons/BPIcon';
import { FC } from 'react';

const BurgerButton: FC<{ onClick: () => void }> = ({ onClick }) => (
  <button onClick={onClick} className="hover:opacity-40">
    <BPIcon icon="burger" className="fill-white scale-[1.7] mr-[8px]" />
  </button>
);

export default BurgerButton;
